export const billsContext = {
  getAccounts: '/accounting-service/api/external/accounts/self',
  getBalance: '/accounting-service/balance/',
};
